
export type TransferStatus = "PENDING" | "COMPLETED" | "FAILED";

export class TransferResponse {
    public readonly id: number;
    public readonly status: TransferStatus;

    constructor() {
    }

    public static fromJson(json: any): TransferResponse {
        return Object.assign(new TransferResponse(), json); // copy properties
    }

    /*public static generateMockPayment(txId: string, status: PaymentStatus = "PAID") {
        const last = txId.lastIndexOf("-");
        if (last !== -1)
            txId = txId.substr(0, last);
        return Object.assign(new PaymentResponse(), {
            id: 5,
            tx_id: txId,
            status: status,
        });
    }*/

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

}
